import { ErrorsService } from './tools/errors.service';
import { ValidatorService } from './tools/validator.service';
import { ConstantsService } from './constants.service';
import { Http, ResponseContentType, URLSearchParams } from '@angular/http';
import { Injectable } from '@angular/core';
import { AutenticacionService } from './autenticacion.service';

declare var $;
declare var moment;

@Injectable()
export class CuentasPorCobrarService {
  public static readonly ARRENDATARIO_TIPO_MIEMBRO: number = 1;
  public static readonly METODO_PAGO_DEFAULT: string = 'PPD';
  public static readonly METODO_PAGO_DEFAULT_VENTA: string = 'PUE';
  public static readonly FORMA_PAGO_DEFAULT: string = '99';
  public static readonly USO_CFDI_DEFAULT: string = 'G03';

  public url:string;

  constructor(private http: Http, 
                private constant: ConstantsService, 
                private validatorService: ValidatorService, 
                private errorService:ErrorsService, 
                private authService: AutenticacionService){
    this.url = constant.apiURL;
  }

  public guardarContrato(contrato) {
    return this.http.post(this.url + '/contratos', contrato, this.authService.getAuthHeaders());
  }

  public listarContratos(page, id_obra, id_proveedor, search?){
    var obra_filter = "";
    if(id_obra){
      obra_filter = "&id_obra="+id_obra;
    }

    var proveedor_filter = "";
    if(id_proveedor){
      proveedor_filter = "&id_proveedor="+id_proveedor;
    }

    var search_filter = "";
    if(search){
      search_filter = "&search="+encodeURIComponent(search);
    }
    return this.http.get(this.url + '/contratos?page='+page+obra_filter+proveedor_filter+search_filter, this.authService.getAuthHeaders());
  }

  public recuperarContrato(id_contrato){
    return this.http.get(this.url + '/contratos/single/'+id_contrato, this.authService.getAuthHeaders());
  }

  public getAllConceptosVisiblesEnContratos(){
    return this.http.get(this.url + '/contratos/conceptos?select=true&solo_visible_en_contratos=true', this.authService.getAuthHeaders());
  }

  public getObras(){
    return this.http.get(this.url + '/contratos/obras?select=true', this.authService.getAuthHeaders());
  }

  public getObrasEmisoras(){
    return this.http.get(this.url + '/publicos/obras/emisoras', this.authService.getAuthHeaders());
  }
  public getProveedores2(){
    return this.http.get(this.url + '/publicos/proveedores/all', this.authService.getAuthHeaders());
  }
  public getProveedores(){
    return this.http.get(this.url + '/contratos/proveedores?select=true', this.authService.getAuthHeaders());
  }

  public getTiposProveedores(){
    return this.http.get(this.url + '/contratos/proveedores/tipo', this.authService.getAuthHeaders());
  }

  public getTiposArrendatarios(){
    return this.http.get(this.url + '/contratos/proveedores/tipo_arrendatario', this.authService.getAuthHeaders());
  }

  public buscarProveedorPorRFC(rfc){
    return this.http.get(this.url + "/publicos/proveedores/rfc/" + rfc, this.authService.getAuthHeaders());
  }

  public buscarProveedorPorId(id){
    return this.http.get(this.url + "/publicos/proveedores/id/" + id, this.authService.getAuthHeaders());
  }

  public getAllTiposServicio(){
    return this.http.get(this.url + '/contratos/tipos_servicio', this.authService.getAuthHeaders());
  }

  public subirArchivoContrato(id_contrato, archivo){
    var data = new FormData();
    data.append('archivo',archivo.input_file);
    return this.http.post(this.url + '/contratos/'+id_contrato+'/archivos/upload',data, this.authService.getAuthHeaders());
  }

  public actualizarArchivoContrato(id_contrato, id_tipo_contrato_archivo, ruta_archivo, nombre_archivo){
    var data = {
      id_tipo_contrato_archivo: id_tipo_contrato_archivo,
      ruta_archivo: ruta_archivo,
      nombre_archivo: nombre_archivo
    };
    return this.http.put(this.url + '/contratos/'+id_contrato+'/archivos',data, this.authService.getAuthHeaders());
  }

  public eliminarArchivoDeContrato(id_contrato, id_contrato_archivo){
    return this.http.delete(this.url + '/contratos/'+id_contrato+'/archivos/'+id_contrato_archivo, this.authService.getAuthHeaders());
  }

  public getReporteCPC(page, id_obra, id_proveedor, fecha_termino, incluir_cobradas,incluir_canceladas,search?){

    var paging = "?";
    if(page){
      paging += "page="+page+"&per_page=100";
    }

    var obra_filter = "";
    if(id_obra){
      obra_filter = "&id_obra="+id_obra;
    }

    var proveedor_filter = "";
    if(id_proveedor){
      proveedor_filter = "&id_proveedor="+id_proveedor;
    }

    var fecha_termino_filter = "";
    if(fecha_termino){
      fecha_termino_filter = "&fecha_termino="+fecha_termino;
    }

    var incluir_cobradas_filter = "";
    if(incluir_cobradas){
      incluir_cobradas_filter = "&incluir_cobradas=1";
    }else{
      incluir_cobradas_filter = "&incluir_cobradas=0";
    }

    var incluir_canceladas_filter = "";
    if(incluir_canceladas){
      incluir_canceladas_filter = "&incluir_canceladas=1";
    }else{
      incluir_canceladas_filter = "&incluir_canceladas=0";
    }

    //Palabra clave: el API busca en miembro, cliente, concepto y numero de oficina.
    var search_filter = "";
    if(search){
      search_filter = "&search="+encodeURIComponent(search);
    }

    return this.http.get(this.url + '/reportes/cuentas_por_cobrar'+paging+obra_filter+proveedor_filter+fecha_termino_filter+incluir_cobradas_filter+incluir_canceladas_filter+search_filter, this.authService.getAuthHeaders());
  }

  public getCPCParaMovimientos(id_obra: number, filtros: any) {
    let myParams = new URLSearchParams();
    myParams.append('validarOrigen', 'false');
    myParams.append('estatus', 'POR_COBRAR,PARCIALMENTE_COBRADO');

    if(id_obra){
      myParams.append('id_obra', id_obra.toString());
    }

    if(filtros.fecha_termino){
      myParams.append('fecha_termino', filtros.fecha_termino);
    }
    
    if(filtros.id_proveedor){
      myParams.append('id_proveedor', filtros.id_proveedor);
    }

    if(filtros.search){
      myParams.append('search', filtros.search);
    }

    if(filtros.importe){
      myParams.append('importe', filtros.importe);
      //console.log("Se agrega campo importe");
    }

    myParams.append('incluir_facturadas', filtros.incluir_facturadas);
    
    const options = this.authService.getAuthHeaders();
    options.params = myParams;

    let serviceUrl = this.url + '/reportes/cuentas_por_cobrar/movimientos';

    return this.http.get(serviceUrl, options);
  } 

  public validarInfoContrato(data, tipo_arrendatario) {
    let error = [];

    if (!data['id_emisor'] || data['id_emisor']==0) {
      error['obra_emisor'] = this.errorService.required;
    }

    // validacion de OBRA
    if (!data['id_obra'] || data['id_obra']==0) {
      error['id_obra'] = this.errorService.required;
    }

    if ($.isEmptyObject(data['espacio_trabajo'])) {
      error['espacio_trabajo'] = this.errorService.required;
    }

    if ($.isEmptyObject(data['fecha_inicio'])) {
      error['fecha_inicio'] = this.errorService.required;
    }

    if ($.isEmptyObject(data['fecha_fin'])) {
      error['fecha_fin'] = this.errorService.required;
    }

    if ($.isEmptyObject(data['uso_cfdi'])) {
      error['uso_cfdi'] = this.errorService.required;
    }

    //Datos del proveedor
    if ($.isEmptyObject(data['proveedor']['rfc'])) {
      error['proveedor_rfc'] = this.errorService.required;
    }

    if ($.isEmptyObject(data['proveedor']['nombre'])) {
      error['proveedor_nombre'] = this.errorService.required;
    }

    if (!data['proveedor']['id_tipo_arrendatario'] || data['proveedor']['id_tipo_arrendatario']==0) {
      error['tipo_proveedor'] = this.errorService.required;
    }

    if ($.isEmptyObject(data['proveedor']['tipo_persona'])) {
      error['persona_proveedor'] = this.errorService.required;
    }

    if ($.isEmptyObject(data['proveedor']['direccion'])) {
      error['proveedor_direccion'] = this.errorService.required;
    }

    if ($.isEmptyObject(data['proveedor']['colonia'])) {
      error['proveedor_colonia'] = this.errorService.required;
    }

    //Validar los múltiples emails
    if(this.validatorService.required(data['proveedor']['email'])){
      var arregloEmails = data['proveedor']['email'].split(";");

      arregloEmails.forEach(email => {
        if(!this.validatorService.email(email.trim())){     
          error['proveedor_email'] = "El correo o los correos no tienen un formato valido";
        }
      });
    }else{
      error['proveedor_email'] = this.errorService.required;
    }

    if ($.isEmptyObject(data['proveedor']['telefono'])) {
      error['proveedor_telefono'] = this.errorService.required;
    }

    let obligadoSolidario = {};
    let apoderadoLegal = {};
    data.obligados_solidarios.forEach(obligadoItem => {
      if(obligadoItem.es_apoderado_legal === 1){
        apoderadoLegal = obligadoItem;
      } else {
        obligadoSolidario = obligadoItem;
      }
    });
    
    if(data.proveedor.id_tipo_arrendatario !== CuentasPorCobrarService.ARRENDATARIO_TIPO_MIEMBRO){
      //Validar los datos del obligado solidario
      if ($.isEmptyObject(obligadoSolidario['nombre'])) {
        error['obligado_solidario_nombre'] = this.errorService.required;
      }
      if ($.isEmptyObject(obligadoSolidario['domicilio'])) {
        error['obligado_solidario_domicilio'] = this.errorService.required;
      }
      if ($.isEmptyObject(obligadoSolidario['email'])) {
        error['obligado_solidario_email'] = this.errorService.required;
      }
      if ($.isEmptyObject(obligadoSolidario['telefono'])) {
        error['obligado_solidario_telefono'] = this.errorService.required;
      }
      if ($.isEmptyObject(obligadoSolidario['rfc'])) {
        error['obligado_solidario_rfc'] = this.errorService.required;
      }
    }

    if(data.proveedor.tipo_persona && data.proveedor.tipo_persona.toLowerCase() ==='moral'){
      //Validar los datos del apoderado legal
      if ($.isEmptyObject(apoderadoLegal['nombre'])) {
        error['apoderado_nombre'] = this.errorService.required;
      }
      if ($.isEmptyObject(apoderadoLegal['domicilio'])) {
        error['apoderado_domicilio'] = this.errorService.required;
      }
      if ($.isEmptyObject(apoderadoLegal['email'])) {
        error['apoderado_email'] = this.errorService.required;
      }
      if ($.isEmptyObject(apoderadoLegal['telefono'])) {
        error['apoderado_telefono'] = this.errorService.required;
      }
      if ($.isEmptyObject(apoderadoLegal['rfc'])) {
        error['apoderado_rfc'] = this.errorService.required;
      }
    }

    return error;
  }

  public validarInfoRenta(data) {
    let error = [];
    if ($.isEmptyObject(data['fecha_inicio'])) {
      error['fecha_inicio'] = this.errorService.required;
    }

    if ($.isEmptyObject(data['fecha_fin'])) {
      error['fecha_fin'] = this.errorService.required;
    }

    //La fecha de termino debe ser mayor a la fecha inicio
    if(this.validatorService.required(data['fecha_inicio']) && this.validatorService.required(data['fecha_fin'])){
      //Aunque el input tenga se vea con formato DD/MM/YYYY el datepicker retorna la fecha en formato YYYY-MM-DD
      var fecha_inicio = moment(data['fecha_inicio'], "YYYY-MM-DD");
      var fecha_fin = moment(data['fecha_fin'], "YYYY-MM-DD");

      if(fecha_inicio.isAfter(fecha_fin)){
        error['fecha_fin'] = "La fecha de termino debe ser mayor a la fecha inicio";  
      }
    }

    if ($.isEmptyObject(data['periodicidad'])) {
      error['periodicidad'] = this.errorService.required;
    }

    if (!data['importe'] || data['importe']==0) {
      error['importe'] = this.errorService.required;
    }

    if (!data['id_concepto'] || data['id_concepto']==0) {
      error['id_concepto'] = this.errorService.required;
    }

    return error;

  }

  public validarInfoMantenimiento(data){

    let error = [];
    // validacion de OBRA
    if ($.isEmptyObject(data['fecha_inicio'])) {
      error['fecha_inicio'] = this.errorService.required;
    }

    if ($.isEmptyObject(data['fecha_fin'])) {
      error['fecha_fin'] = this.errorService.required;
    }

    //La fecha de termino debe ser mayor a la fecha inicio
    if(this.validatorService.required(data['fecha_inicio']) && this.validatorService.required(data['fecha_fin'])){
      //Aunque el input tenga se vea con formato DD/MM/YYYY el datepicker retorna la fecha en formato YYYY-MM-DD
      var fecha_inicio = moment(data['fecha_inicio'], "YYYY-MM-DD");
      var fecha_fin = moment(data['fecha_fin'], "YYYY-MM-DD");

      if(fecha_inicio.isAfter(fecha_fin)){
        error['fecha_fin'] = "La fecha de termino debe ser mayor a la fecha inicio";  
      }
    }

    if ($.isEmptyObject(data['periodicidad'])) {
      error['periodicidad'] = this.errorService.required;
    }

    if (!data['importe'] || data['importe']==0) {
      error['importe'] = this.errorService.required;
    }

    if (!data['id_concepto'] || data['id_concepto']==0) {
      error['id_concepto'] = this.errorService.required;
    }

    return error;

  }

  public validarInfoServicio(data){

    let error = [];
    
    if ($.isEmptyObject(data['nombre'])) {
      error['servicio_nombre'] = this.errorService.required;
    }

    if ($.isEmptyObject(data['fecha_inicio'])) {
      error['fecha_inicio'] = this.errorService.required;
    }

    //Si es un servicio periodico se debe validar la fecha fin y el tipo de periodicidad
    if(data['tiene_periodicidad']) {

      if($.isEmptyObject(data['fecha_fin'])) {
        error['fecha_fin'] = this.errorService.required;
      }

      //La fecha de termino debe ser mayor a la fecha inicio
      if(this.validatorService.required(data['fecha_inicio']) && this.validatorService.required(data['fecha_fin'])){
        //Aunque el input tenga se vea con formato DD/MM/YYYY el datepicker retorna la fecha en formato YYYY-MM-DD
        var fecha_inicio = moment(data['fecha_inicio'], "YYYY-MM-DD");
        var fecha_fin = moment(data['fecha_fin'], "YYYY-MM-DD");

        if(fecha_inicio.isAfter(fecha_fin)){
          error['fecha_fin'] = "La fecha de termino debe ser mayor a la fecha inicio";  
        }
      }

      if($.isEmptyObject(data['periodicidad'])) {
        error['periodicidad'] = this.errorService.required;
      }
      
    }


    if (!data['importe'] || data['importe']==0) {
      error['importe'] = this.errorService.required;
    }

    if(!data['id_concepto'] || data['id_concepto']==0){
      error['conceptos'] = this.errorService.required;
    }

    if(!data['id_tipo_servicio'] || data['id_tipo_servicio']==0){
      error['tipo_servicio'] = this.errorService.required;
    }

    return error;
    
  }

  /** Convenios */

  public listarConvenios(page, id_contrato){
    return this.http.get(this.url + '/contratos/'+id_contrato+'/convenios?page='+page, this.authService.getAuthHeaders());
  }

  public recuperarConvenio(id_convenio){
    return this.http.get(this.url + '/contratos/convenios/'+id_convenio, this.authService.getAuthHeaders());
  }

  public guardarConvenio(id_contrato, convenio){

    var data = {
      comentarios: convenio.comentarios,
      especificacion_json: convenio //se guarda todo el convenio en json
    };
    return this.http.post(this.url + '/contratos/'+id_contrato+'/convenios', data, this.authService.getAuthHeaders());

  }

  public eliminarConvenio(id_convenio){
    return this.http.delete(this.url + '/contratos/convenios/'+id_convenio, this.authService.getAuthHeaders());
  }

  public subirArchivoConvenio(id_convenio, archivo){
    var data = new FormData();
    data.append('archivo',archivo.input_file);
    return this.http.post(this.url + '/contratos/convenios/'+id_convenio+'/archivos/upload',data, this.authService.getAuthHeaders());
  }

  public autorizarConvenio(convenio){
    var data = {
      id_convenio: convenio.id_convenio,
      comentarios_autorizacion: convenio.comentarios_autorizacion
    };
    return this.http.post(this.url + '/contratos/convenios/autorizacion', data, this.authService.getAuthHeaders());
  }

  public actualizarConvenio(convenio){

    var data = {
      comentarios: convenio.comentarios,
      especificacion_json: convenio, //se guarda todo el convenio en json
      documento_url: convenio.documento_url?convenio.documento_url:null,
      documento_nombre: convenio.documento_nombre?convenio.documento_nombre:null
    };
    return this.http.put(this.url + '/contratos/convenios/'+convenio.id_convenio, data, this.authService.getAuthHeaders());

  }

  public facturarCuentasPorCobrar(factura: any){
    const serviceUrl = this.url + '/reportes/cuentas_por_cobrar/facturar';
    return this.http.post(serviceUrl, factura, this.authService.getAuthHeaders());
  }

  /**
   * 
   * Requiere tener permiso para ver el reporte de cuentas por cobrar
   */
  public obtenerCuentasPorCobrarRelacionadas(id_cuenta_por_cobrar: number) {
    let myParams = new URLSearchParams();
     
    myParams.append('id_cuenta_por_cobrar', id_cuenta_por_cobrar.toString());

    const options = this.authService.getAuthHeaders();
    options.params = myParams;

    const serviceUrl = this.url + '/reportes/cuentas_por_cobrar/cuentas-relacionadas';
    return this.http.get(serviceUrl, options);
  } 

  public validarDatosAFacturar(factura: any){
    let error = [];

    if(this.validatorService.required(factura.email_facturacion)){
      var arregloEmails = factura.email_facturacion.split(";");

      arregloEmails.forEach(email => {
        if(!this.validatorService.email(email.trim())){     
          error["emails_facturacion"] = "El correo o los correos no tienen un formato valido ";
        }
      });
    }

    if(!this.validatorService.required(factura.email_facturacion)){
        error["emails_facturacion"] = this.errorService.required;
    }

    if(!this.validatorService.required(factura.payment_form)){
        error["payment_form"] = this.errorService.required;
    }

    if(!this.validatorService.required(factura.payment_method)){
        error["payment_method"] = this.errorService.required;
    }

    if(!this.validatorService.required(factura.uso_cfdi)){
      error["uso_cfdi"] = this.errorService.required;
    }

    return error;
  }

  public validarRecepcionPagos(recepcionPagos: any){
    let error = [];

    if(this.validatorService.required(recepcionPagos.email_facturacion)){
      var arregloEmails = recepcionPagos.email_facturacion.split(";");

      arregloEmails.forEach(email => {
        if(!this.validatorService.email(email.trim())){     
          error["emails_facturacion"] = "El correo o los correos no tienen un formato valido ";
        }
      });
    }

    if(recepcionPagos.pagos.length == 0){
      error["documentos"] = "Agrega los documentos relacionados a la recepción del pago";
    }

    recepcionPagos.pagos.forEach(pago => {
      pago.error = {};
      
      if(!this.validatorService.required(pago.parcialidad)){
        pago.error["parcialidad"] = this.errorService.required;
      }

      if(!this.validatorService.required(pago.forma_pago)){
        pago.error["forma_pago"] = this.errorService.required;
      }

      if(!this.validatorService.required(pago.saldo_pendiente)){
        pago.error["saldo_pendiente"] = this.errorService.required;
      }

      if(!this.validatorService.required(pago.importe_pagado)){
        pago.error["importe_pagado"] = this.errorService.required;
      }

      if(!this.validatorService.required(pago.fecha_pago)){
        pago.error["fecha_pago"] = this.errorService.required;
      }

      //Si hubo algún error en los datos de los pagos, agregamos una propiedad al objeto error, para que reporte que hay errores por resolver
      if (Object.entries(pago.error).length > 0) {
        error["pagos"] = "Hay errores en los pagos";
      }
      
    });

    return error;
  }

  public recuperarContratoParaConvenio(id_contrato){
    let serviceUrl = `${this.url}/contratos/${id_contrato}/datos-para-convenio`
    return this.http.get(serviceUrl, this.authService.getAuthHeaders());
  }

  /**
   * Seccion de contratos
   */

  public esUnContratoValidoParaCrearUnNuevoConvenio(id_contrato: number){
    let serviceUrl = `${this.url}/contratos/esValidoParaCrearUnNuevoConvenio/${id_contrato}`;
    return this.http.get(serviceUrl, this.authService.getAuthHeaders());
  }

  public eliminarContrato(id_contrato){
    let serviceUrl = `${this.url}/contratos/${id_contrato}`;
    return this.http.delete(serviceUrl, this.authService.getAuthHeaders());
  }

  /**
   * Intereses moratorios
   */
  public listarCuentasInteresesMoratorios(id_cuenta_por_cobrar){
    let myParams = new URLSearchParams();
    myParams.append('id_cuenta_por_cobrar', id_cuenta_por_cobrar);

    const options = this.authService.getAuthHeaders();
    options.params = myParams;

    let serviceUrl = this.url + '/reportes/cuentas_por_cobrar/interese_moratorios';
    return this.http.get(serviceUrl, options);
  }

  public eliminarCuentaInteresesMoratorios(id_interes_por_cobrar){
    const options = this.authService.getAuthHeaders();
    let serviceUrl = `${this.url}/reportes/cuentas_por_cobrar/interese_moratorios/${id_interes_por_cobrar}`;

    return this.http.delete(serviceUrl, options);
  }

  /**
   * Recepción de pagos
   */
  public facturarRecepcionPagos(recepcionPagos: any){
    const serviceUrl = this.url + '/reportes/cuentas_por_cobrar/recepciones-pagos/facturar';
    console.log('recepcionPagos', recepcionPagos);
    return this.http.post(serviceUrl, recepcionPagos, this.authService.getAuthHeaders());
  }

  public listarFacturasRecepcionesPago(id_cuenta_por_cobrar){
    let myParams = new URLSearchParams();
    myParams.append('id_cuenta_por_cobrar', id_cuenta_por_cobrar);

    const options = this.authService.getAuthHeaders();
    options.params = myParams;

    let serviceUrl = this.url + '/reportes/cuentas_por_cobrar/recepciones-pagos';
    return this.http.get(serviceUrl, options);
  }
  public eliminarCuentaPorCobrar(id_cuenta_por_cobrar){
    let urlService = `${this.url}/reportes/cuentas_por_cobrar/eliminar/${id_cuenta_por_cobrar}`;
    const options = this.authService.getAuthHeaders();
    console.log(id_cuenta_por_cobrar);
    return this.http.post(urlService,id_cuenta_por_cobrar,options);
  }

  public createMovimientosObra(data) {
    //console.log("createMovimientosObra this.service_url: ",this.service_url);
    //console.log("createMovimientosObra data: ",data);
    const urlService = `${this.url}/reportes/cuentas_por_cobrar/nota-credito`;
    return this.http.post(urlService, data, this.authService.getAuthHeaders());
  }

  public providerInfo(id_obra){
    const urlService = `${this.url}/contratos/provider_info`;
    return this.http.get(urlService+'?id_proveedor='+id_obra, this.authService.getAuthHeaders());
  }

  public exportCSV(fechaTermino,incluir_cobradass,incluir_canceladass,id_obra, id_proveedor) {
    const options = this.authService.getAuthHeaders();
    options.responseType = ResponseContentType.Blob;
    const incluir_cobradas = incluir_cobradass == false ? 0:1;
    const incluir_canceladas = incluir_canceladass == false ? 0:1;
    let id_obra_str = "";
    let id_proveedor_str = "";
    if (id_obra){
      id_obra_str = `&id_obra=${id_obra}`;
    } 
    if (id_proveedor){
      id_proveedor_str = `&id_proveedor=${id_proveedor}`;
    }
    let serviceUrl = this.url + '/reportes/cuentas_por_cobrar/exportar?'+`fecha_termino=${fechaTermino}`
    + `&incluir_cobradas=${incluir_cobradas}` + `&incluir_canceladas=${incluir_canceladas}` + 
    id_obra_str + id_proveedor_str;

    return this.http.get(serviceUrl, options)
    .map((response) => {
      let link = document.createElement('a');
      link.href = window.URL.createObjectURL(response.blob());
      const contentDispositionHeader = response.headers.get('content-disposition');
      const result = contentDispositionHeader.split(';')[1].trim().split('=')[1];
      link.download = result.replace(/"/g, '');
      document.body.appendChild(link); 
      link.click();
      setTimeout(() => {
        link.remove();
      }, 200);
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/services/cuentas-por-cobrar.service.ts